"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONTACT_CARD_ENTER_DELAY = void 0;
const CONTACT_CARD_ENTER_DELAY = 1000;
exports.CONTACT_CARD_ENTER_DELAY = CONTACT_CARD_ENTER_DELAY;
//# sourceMappingURL=contactPickerConstants.js.map